import {useEffect, useState} from 'react';

const PHOTON_LINK_URL = 'https://api.photonlink.doubtech.com/shared/gZl0Hr7XB9yHCDNrPsi9/media';

export const useGalleryEntries = (limit) => {
    const [galleryEntries, setGalleryEntries] = useState([]);

    useEffect(() => {
        const fetchGalleryEntries = async () => {
            try {
                const response = await fetch(PHOTON_LINK_URL);
                const json = await response.json();
                if (json.success && json.data) {
                    const entries = limit ? json.data.slice(0, limit) : json.data;
                    setGalleryEntries(entries.map(item => ({
                        id: item.id,
                        url: item.url,
                        caption: item.description || item.name,
                        width: item.width,
                        height: item.height,
                    })));
                }
            } catch (e) {
                console.error('Failed to fetch gallery:', e);
            }
        };

        fetchGalleryEntries();
    }, [limit]);

    return [galleryEntries];
}
